import styled from 'styled-components';

export const TagContainer = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.antiFlashWhite};
  border-radius: ${({ theme }) => theme.radius.l};
  padding: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.sm};
  margin: ${({ theme }) => theme.spacing.xs};
`;

export const TagText = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s};
`;

export const DeleteIcon = styled.span`
  cursor: pointer;
  margin-left: ${({ theme }) => theme.spacing.s};
`;
